import { render } from "./FeedBackTest.vue?vue&type=template&id=67221806&scoped=true&lang=html"
import script from "./FeedBackTest.vue?vue&type=script&lang=js"
export * from "./FeedBackTest.vue?vue&type=script&lang=js"

import "./FeedBackTest.vue?vue&type=style&index=0&id=67221806&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-67221806"

export default script